import api from '@/services/api'
import NodeLockActions from './actions-types'

export default {
  [NodeLockActions.CHECK_NODE]({}, data) {
    return new Promise((resolve, reject) => {
      api.node.nodelock
        .checkNode(data)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}
